import HomePage from '~/pages' // dynamic import of the Home component doesn't work and produces ".js" file

const packageRaffleId = 'raffle'
const packagePaymentsId = 'payments'
const packageLotteryId = 'lottery'
// const packageUserTrackingId = 'user-tracking'
const EXTERNAL_GAMES_IDS = {
  AMERICAN_ROULETTE_3D: 'e-game-american-roulette-3d'
}
import sportBetsRoutes from 'packages/sports-bet/resources/js/routes/routes'
import userTrackingRoutes from 'packages/user-tracking/resources/js/routes/routes'


function page (path) {
  return () => import(/* webpackChunkName: 'js/[request]' */ `~/pages/${path}`).then(m => m.default || m)
}

export default [
  // Sport Bet Routes
  ...sportBetsRoutes,
  ...userTrackingRoutes,

  // home page
  // { path: '/old-homepage', name: 'new-homepage', component: HomePage },
  { path: '/', name: 'home', component: page('new-homepage') },
  { path: '/homepage-v2', name: 'homev2', component: page('homepage-v2') },

  { path: '/changelog', name: 'changelog', component: page('changelog') },

  // authentication
  { path: '/login', name: 'login', component: page('login'), meta: { layout: 'auth' } },
  { path: '/2fa', name: '2fa', component: page('2fa'), meta: { layout: 'auth' } },
  { path: '/register', name: 'register', component: page('register'), meta: { layout: 'auth' } },
  { path: '/password/reset', name: 'password.email', component: page('password/email'), meta: { layout: 'auth' } },
  { path: '/password/reset/:token', name: 'password.reset', component: page('password/reset'), meta: { layout: 'auth' } },
  { path: '/email', name: 'verification.index', component: page('email') },
  { path: '/email/verify/:id/:hash', name: 'verification.verify', component: page('email/verify') },

  // games
  { path: '/games/:game/:slug?', name: 'game', component: page('games') },

  // external games
  // { path: '/e-games/ar3d/american-roulette-3d', name: 'e-games.american-roulette-3d', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${EXTERNAL_GAMES_IDS.AMERICAN_ROULETTE_3D}/resources/js/pages/game`), meta: { layout: 'external-game' } },

  // raffles
  // {
  //   path: '/raffles',
  //   name: 'raffles',
  //   redirect: { name: 'raffles.current' },
  //   component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/raffles`),
  //   children: [
  //     { path: 'current', name: 'raffles.current', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/raffles/current`) },
  //     { path: 'completed', name: 'raffles.completed', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/raffles/completed`) }
  //   ]
  // },


  // users
  { path: '/users/:id', name: 'users.show', component: page('users/show'), props: true },

  // user
  { path: '/user/edit', name: 'user.edit', component: page('user/edit') },

  {
    path: '/user/security',
    name: 'user.security',
    redirect: { name: 'user.security.password' },
    component: page('user/security'),
    children: [
      { path: 'password', name: 'user.security.password', component: page('user/security/password') },
      { path: '2fa', name: 'user.security.2fa', component: page('user/security/2fa') }
    ]
  },

  {
    path: '/user/affiliate',
    name: 'user.affiliate',
    redirect: { name: 'user.affiliate.info' },
    component: page('user/affiliate'),
    children: [
      { path: 'info', name: 'user.affiliate.info', component: page('user/affiliate/info') },
      { path: 'commissions', name: 'user.affiliate.commissions', component: page('user/affiliate/commissions') },
      { path: 'stats', name: 'user.affiliate.stats', component: page('user/affiliate/stats') }
    ]
  },

  { path: '/user/account/transactions', name: 'user.account.transactions', component: page('user/account/transactions') },
  { path: '/user/account/bank-accounts', name: 'user.account.bank-accounts', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/bank-accounts`) },

  { path: '/user/account/deposits', name: 'user.account.deposits.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/deposits`) },
  { path: '/user/account/deposits/create', name: 'user.account.deposits.create', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/deposits/create`) },
  { path: '/user/account/deposits/:id/complete', name: 'user.account.deposits.complete', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/deposits/complete`), props: true },

  { path: '/user/account/withdrawals', name: 'user.account.withdrawals.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/withdrawals`) },
  { path: '/user/account/withdrawals/create', name: 'user.account.withdrawals.create', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/user/account/withdrawals/create`) },

  // games history
  {
    path: '/history',
    name: 'history',
    redirect: { name: 'history.user' },
    component: page('history'),
    children: [
      { path: 'user', name: 'history.user', component: page('history/user') },
      { path: 'recent', name: 'history.recent', component: page('history/recent') },
      { path: 'wins', name: 'history.wins', component: page('history/wins') },
      { path: 'losses', name: 'history.losses', component: page('history/losses') },
      { path: 'games/:id', name: 'history.games.show', component: page('history/games/show'), props: true },
      { path: 'games/:id/details', name: 'history.games.details', component: page('history/games/details'), props: true },
      { path: 'games/:id/verify', name: 'history.games.verify', component: page('history/games/verify'), props: true }
    ]
  },

  // leaderboard
  { path: '/leaderboard', name: 'leaderboard', component: page('leaderboard') },


  // Lottery
  {
    path: '/user/lottery',
    name: 'user.lottery.tickets.index',
    redirect: { name: 'user.lottery.tickets.tickets-in-process' },
    component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/tickets/index`),
    children: [
      { path: 'panel', name: 'user.lottery.panel', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/panel`) },
      { path: 'dashboard', name: 'user.lottery.dashboard', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/dashboard`) },
      { path: 'tickets-in-process', name: 'user.lottery.tickets.tickets-in-process', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/tickets/tickets-in-process`) },
      { path: 'past-tickets', name: 'user.lottery.tickets.past-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/tickets/past-tickets`) },
      { path: 'won-tickets', name: 'user.lottery.tickets.won-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/tickets/won-tickets`) },
    ]
  },
  { path: '/user/lottery/create-ticket', name: 'user.lottery.create-ticket', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/create-ticket`) },
  { path: '/user/lottery/ticket-voucher/:id', name: 'user.lottery.ticket-voucher', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/user/tickets/ticket-voucher`), props: true },

  /*
   *
   *
   *  BACKEND
   *
   *
   */

  // dashboard
  {
    path: '/admin/dashboard',
    name: 'admin.dashboard.index',
    redirect: { name: 'admin.dashboard.users' },
    component: page('admin/dashboard'),
    children: [
      { path: 'users', name: 'admin.dashboard.users', component: page('admin/dashboard/users') },
      { path: 'affiliates', name: 'admin.dashboard.affiliates', component: page('admin/dashboard/affiliates') },
      { path: 'games', name: 'admin.dashboard.games', component: page('admin/dashboard/games') },
      { path: 'accounting', name: 'admin.dashboard.accounting', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/dashboard/accounting`) }
    ]
  },
  // My Dashboard - All stuff related to me
  {
    path: '/admin/my-dashboard',
    name: 'admin.my-dashboard.index',
    redirect: { name: 'admin.my-dashboard.general' },
    component: page('admin/my-dashboard'),
    children: [
      { path: 'general', name: 'admin.my-dashboard.general', component: page('admin/my-dashboard/general') },
      { path: 'global', name: 'admin.my-dashboard.global', component: page('admin/my-dashboard/global') },
    ]
  },

  {
    path: '/admin/support-tickets',
    name: 'admin.support-tickets.index',
    component: page('admin/support-tickets'),
  },

  {
    path: '/admin/manual-transactions',
    name: 'admin.manual-transactions.index',
    component: page('admin/manual-transactions/manual-transactions'),
  },

  // Sites
  { path: '/admin/sites', name: 'admin.sites.index', component: page('admin/sites/sites'), props: true },

  {
    path: '/admin/users',
    name: 'admin.users.index',
    component: page('admin/users/index'),
    redirect: { name: 'admin.users.list' },
    children: [
      { path: 'list', name: 'admin.users.list', component: page('admin/users/user-list') },
      { path: 'users-without-referrer', name: 'admin.users.users-without-referrer.list', component: page('admin/users/user-without-referrer-list') },
      { path: 'users-activity', name: 'admin.users.users-activity', component: page('admin/users/user-activity') },
      { path: 'users-bank-transfer', name: 'admin.users.users-bank-transfer', component: page('admin/users/user-bank-transfer') },
      { path: 'report', name: 'admin.users.users-report', component: page('admin/users/report') },
      // { path: 'activityByUser', name: 'admin.users.activityByUser', component: page('admin/users/activityByUser') },
    ]
},

  { path: '/admin/users/:id', name: 'admin.users.show', component: page('admin/users/show'), props: true },
  { path: '/admin/users/activity-by-user/:id', name: 'admin.users.activity-by-user', component: page('admin/users/activity-by-user'), props: true },
  { path: '/admin/users/:id/edit', name: 'admin.users.edit', component: page('admin/users/edit'), props: true },
  { path: '/admin/users/:id/delete', name: 'admin.users.delete', component: page('admin/users/delete'), props: true },
  { path: '/admin/users/:id/referrers', name: 'admin.users.referrers', component: page('admin/users/referrer'), props: true },
  { path: '/admin/users/:id/mail', name: 'admin.users.mail', component: page('admin/users/mail'), props: true },

  { path: '/admin/sellers', name: 'admin.sellers.index', component: page('admin/sellers/index') },
  { path: '/admin/sellers/create', name: 'admin.sellers.create', component: page('admin/sellers/create'), props: true },
  { path: '/admin/sellers/:id', name: 'admin.sellers.show', component: page('admin/sellers/show'), props: true },
  { path: '/admin/sellers/:id/edit', name: 'admin.sellers.edit', component: page('admin/sellers/edit'), props: true },
  { path: '/admin/sellers/:id/delete', name: 'admin.sellers.delete', component: page('admin/sellers/delete'), props: true },
  { path: '/admin/sellers/:id/mail', name: 'admin.sellers.mail', component: page('admin/sellers/mail'), props: true },
  { path: '/admin/sellers/:id/dashboard', name: 'admin.sellers.dashboard', component: page('admin/sellers/dashboard'), props: true },

  { path: '/admin/supervisors', name: 'admin.supervisors.index', component: page('admin/supervisors/index') },
  { path: '/admin/supervisors/create', name: 'admin.supervisors.create', component: page('admin/supervisors/create'), props: true },
  { path: '/admin/supervisors/:id', name: 'admin.supervisors.show', component: page('admin/supervisors/show'), props: true },
  { path: '/admin/supervisors/:id/edit', name: 'admin.supervisors.edit', component: page('admin/supervisors/edit'), props: true },
  { path: '/admin/supervisors/:id/delete', name: 'admin.supervisors.delete', component: page('admin/supervisors/delete'), props: true },
  { path: '/admin/supervisors/:id/dashboard', name: 'admin.supervisors.dashboard', component: page('admin/supervisors/dashboard'), props: true },

  { path: '/admin/accounts', name: 'admin.accounts.index', component: page('admin/accounts/index') },
  { path: '/admin/accounts/:id', name: 'admin.accounts.show', component: page('admin/accounts/show'), props: true },
  { path: '/admin/accounts/:id/debit', name: 'admin.accounts.debit', component: page('admin/accounts/debit'), props: true },
  { path: '/admin/accounts/:id/credit', name: 'admin.accounts.credit', component: page('admin/accounts/credit'), props: true },
  { path: '/admin/accounts/:id/transactions', name: 'admin.accounts.transactions', component: page('admin/accounts/transactions'), props: true },
  { path: '/admin/generic-transactions/dashboard', name: 'admin.generic-transactions.dashboard', component: page('admin/generic-transactions/dashboard'), props: true },

  { path: '/tutorials/:id', name: 'tutorial.show', component: page('tutorial/tutorialsDetails'), props: true  },
  { path: '/tutorials', name: 'tutorial.list', component: page('tutorial/tutorialsList') , props: true },


  /*
   *
   * Lottery
   *
   */

  {
    path: '/admin/lottery',
    name: 'admin.lottery.index',
    redirect: { name: 'admin.lottery.dashboard' },
    component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/index`),
    children: [
      { path: 'dashboard', name: 'admin.lottery.dashboard', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/dashboard`) },
      { path: 'lottery-banks', name: 'admin.lottery.lottery-banks', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/lottery-banks`) },
      { path: 'results', name: 'admin.lottery.results', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/lottery-banks/results`) },
      { path: 'voucher-ticket', name: 'admin.lottery.voucher-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/voucher-tickets`) },
      { path: 'tickets-in-process', name: 'admin.lottery.tickets-in-process', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/tickets/tickets-in-process`) },
      { path: 'won-tickets', name: 'admin.lottery.won-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/tickets/won-tickets`) },
      { path: 'past-tickets', name: 'admin.lottery.past-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/tickets/past-tickets`) },
      { path: 'tickets', name: 'admin.lottery.tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/tickets`) },
      { path: 'lottery-banks/:id/edit', name: 'admin.lottery.lottery-banks.edit', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/lottery-banks/edit`), props: true },
      { path: 'configuration', name: 'admin.lottery.configuration', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/configuration`) },
      { path: 'user-tickets', name: 'admin.lottery.user-tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/user-tickets`) },
      { path: 'sellers', name: 'admin.lottery.sellers', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageLotteryId}/resources/js/pages/admin/sellers`) },
    ]
  },

  /*
   *
   * User Tracking
   *
   */

  // {
  //   path: '/admin/user-tracking',
  //   name: 'admin.user-tracking.index',
  //   redirect: { name: 'admin.user-tracking.dashboard' },
  //   component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageUserTrackingId}/resources/js/pages/admin/dashboard`),
  //   children: [
  //     { path: 'dashboard', name: 'admin.user-tracking.dashboard', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageUserTrackingId}/resources/js/pages/admin/dashboard`) },
  //   ]
  // },
  /*
   *
   * Reports
   *
   */

  {
    path: '/admin/reports',
    name: 'admin.reports.index',
    redirect: { name: 'admin.reports.daily-report' },
    component: page('admin/reports/index'),
    children: [
      { path: 'daily-report', name: 'admin.reports.daily-report', component: page('admin/reports/daily-report') },
      { path: 'weekly-report', name: 'admin.reports.weekly-report', component: page('admin/reports/weekly-report') },
    ]
  },

  // { path: '/admin/raffles', name: 'admin.raffles.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/admin/raffles`) },
  // { path: '/admin/raffles/create', name: 'admin.raffles.create', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/admin/raffles/create`) },
  // { path: '/admin/raffles/:id/edit', name: 'admin.raffles.edit', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/admin/raffles/edit`), props: true },
  // { path: '/admin/raffles/:id/complete', name: 'admin.raffles.complete', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/admin/raffles/complete`), props: true },
  // { path: '/admin/raffles/:id/tickets', name: 'admin.raffles.tickets', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageRaffleId}/resources/js/pages/admin/raffles/tickets`), props: true },

  { path: '/admin/payment-banks', name: 'admin.payment-banks.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/payment-banks`) },

  { path: '/admin/deposits', name: 'admin.deposits.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposits`) },
  { path: '/admin/deposits/dashboard', name: 'admin.deposits.dashboard', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposits/dashboard`) },
  { path: '/admin/deposits/:id', name: 'admin.deposits.show', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposits/show`), props: true },
  { path: '/admin/deposits/:id/transaction', name: 'admin.deposits.transaction', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposits/transaction`), props: true },

  { path: '/admin/withdrawals', name: 'admin.withdrawals.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawals`) },
  { path: '/admin/withdrawals/dashboard', name: 'admin.withdrawals.dashboard', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawals/dashboard`) },
  { path: '/admin/withdrawals/:id', name: 'admin.withdrawals.show', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawals/show`), props: true },
  { path: '/admin/withdrawals/:id/transaction', name: 'admin.withdrawals.transaction', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawals/transaction`), props: true },

  { path: '/admin/withdrawal-methods', name: 'admin.withdrawal-methods.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawal-methods`) },
  { path: '/admin/withdrawal-methods/create', name: 'admin.withdrawal-methods.create', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawal-methods/create`), props: true },
  { path: '/admin/withdrawal-methods/:id/info', name: 'admin.withdrawal-methods.info', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-withdrawal-methods/info`), props: true, meta: { type: 'withdrawal' } },
  { path: '/admin/withdrawal-methods/:id/balance', name: 'admin.withdrawal-methods.balance', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-withdrawal-methods/balance`), props: true, meta: { type: 'withdrawal' } },
  { path: '/admin/withdrawal-methods/:id/edit', name: 'admin.withdrawal-methods.edit', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawal-methods/edit`), props: true },
  { path: '/admin/withdrawal-methods/:id/delete', name: 'admin.withdrawal-methods.delete', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/withdrawal-methods/delete`), props: true },

  { path: '/admin/deposit-methods', name: 'admin.deposit-methods.index', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-methods`) },
  { path: '/admin/deposit-methods/create', name: 'admin.deposit-methods.create', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-methods/create`), props: true },
  { path: '/admin/deposit-methods/:id/info', name: 'admin.deposit-methods.info', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-withdrawal-methods/info`), props: true, meta: { type: 'deposit' } },
  { path: '/admin/deposit-methods/:id/balance', name: 'admin.deposit-methods.balance', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-withdrawal-methods/balance`), props: true, meta: { type: 'deposit' } },
  { path: '/admin/deposit-methods/:id/edit', name: 'admin.deposit-methods.edit', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-methods/edit`), props: true },
  { path: '/admin/deposit-methods/:id/delete', name: 'admin.deposit-methods.delete', component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packagePaymentsId}/resources/js/pages/admin/deposit-methods/delete`), props: true },

  { path: '/admin/games', name: 'admin.games.index', component: page('admin/games/index') },
  { path: '/admin/games/:id', name: 'admin.games.show', component: page('admin/games/show'), props: true },
  { path: '/admin/games/:id/details', name: 'admin.games.details', component: page('admin/games/details'), props: true },

  {
    path: '/admin/affiliate',
    name: 'admin.affiliate.index',
    redirect: { name: 'admin.affiliate.tree' },
    component: page('admin/affiliate'),
    children: [
      { path: 'tree', name: 'admin.affiliate.tree', component: page('admin/affiliate/tree') },
      { path: 'commissions', name: 'admin.affiliate.commissions.index', component: page('admin/affiliate/commissions') },
      { path: 'commissions/:id', name: 'admin.affiliate.commissions.show', component: page('admin/affiliate/commissions/show'), props: true },
      { path: 'commissions/:id/reject', name: 'admin.affiliate.commissions.reject', component: page('admin/affiliate/commissions/reject'), props: true },
      { path: 'commissions/:id/approve', name: 'admin.affiliate.commissions.approve', component: page('admin/affiliate/commissions/approve'), props: true }
    ]
  },
  {
    path: '/admin/chat',
    name: 'admin.chat.index',
    redirect: { name: 'admin.chat.rooms.index' },
    component: page('admin/chat'),
    children: [
      { path: 'rooms', name: 'admin.chat.rooms.index', component: page('admin/chat/rooms') },
      { path: 'rooms/create', name: 'admin.chat.rooms.create', component: page('admin/chat/rooms/create') },
      { path: 'rooms/:id/edit', name: 'admin.chat.rooms.edit', component: page('admin/chat/rooms/edit'), props: true },
      { path: 'rooms/:id/delete', name: 'admin.chat.rooms.delete', component: page('admin/chat/rooms/delete'), props: true },
      { path: 'messages', name: 'admin.chat.messages.index', component: page('admin/chat/messages') },
      { path: 'messages/:id/delete', name: 'admin.chat.messages.delete', component: page('admin/chat/messages/delete'), props: true }
    ]
  },

  { path: '/admin/settings', name: 'admin.settings.index', component: page('admin/settings') },

  { path: '/admin/maintenance', name: 'admin.maintenance.index', component: page('admin/maintenance') },

  { path: '/admin/add-ons', name: 'admin.add-ons.index', component: page('admin/add-ons') },
  { path: '/admin/add-ons/:id/install', name: 'admin.add-ons.install', component: page('admin/add-ons/install'), props: true },
  { path: '/admin/add-ons/:id/changelog', name: 'admin.add-ons.changelog', component: page('admin/add-ons/changelog'), props: true },

  { path: '/admin/license', name: 'admin.license.index', component: page('admin/license') },

  // static pages
  { path: '/pages/:id', name: 'page', component: page('pages'), props: true },

  { path: '/page/:slug', name: 'contentful-page', component: page('contentful-page'), props: true },

  // error page
  { path: '/offline', name: 'offline', component: page('offline') },
  { path: '/503', name: '503', component: page('503') },
  { path: '*', name: '404', component: page('404') },

  // support page
  { path: '/support', name: 'support', component: page('support') }
]
